// React imports.
import React, { Component } from "react";
const DataSubCategories = ({ fieldSubCategories, selectedSubCategoryId, setSelectedSubCategoryId }) => (
  <div className="verticalList" >
    {fieldSubCategories
      .map(field => {
        return (
          <nav key={field.subCategoryId} className={"navbar bg-light " + (field.subCategoryId == selectedSubCategoryId ? "selectedListItem":"") }>
            <a href="#" onClick={e => { setSelectedSubCategoryId(e, field.subCategoryId) }}>
              {field.subCategoryName}
            </a>
          </nav>
        );
    })}
  </div>
);

export default DataSubCategories;
